import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  chart,
}) => new Promise((resolve) => {
  nsApi.post({
    object: 'chart',
    action: 'update',
  }, {
    domain,
    user,
    id: chart.id,
    dashboard_id: chart.dashboard_id,
    name: chart.name,
    type: chart.type,
    properties: JSON.stringify(chart.properties),
    data_sources: JSON.stringify(chart.data_sources),
  }).then((res) => {
    resolve(res);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
